import { createSlice } from '@reduxjs/toolkit';
import type { MediaState } from './type';
import { fetchMediaConfig } from './actions';
import { MEDIA_ENABLE_VIDEO } from 'constants/media';

const initialState: MediaState = {
  config: {
    enable_video: MEDIA_ENABLE_VIDEO,
  },
  isFetching: false,
};

const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMediaConfig.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchMediaConfig.fulfilled, (state, action) => {
        state.config = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchMediaConfig.rejected, (state) => {
        state.isFetching = false;
      });
  },
});

export const mediaReducer = mediaSlice.reducer;
